import './TWButton.scss'
import { classify } from "../../../helpers"
import { useHistory } from "react-router-dom";

const TWButton = ({
	to,
	text,
	size,
	onClick,
	outlined,
	disabled,
	children,
	className = '',
	color = 'secondary2'
}) => {

	const history = useHistory()

	const handleOnClick = event => {
		to
			? history.push(to)
			: onClick && onClick(event)
	}
	return (
		<button
			disabled={disabled}
			className={classify("font-bold rounded border", className, {
				text,
				outlined,
				[color]: color,
				'text-sm py-2 px-3 md:py-3 md:px-4 lg:py-4 lg:px-5 lg:text-xl': size === 'lg',
				'text-sm py-1 px-3 lg:py-3 lg:px-4 lg:text-xl': size === 'md',
				'py-2 px-2 sm:px-3 text-sm sm:text-base': size === 'sm',
				'py-1 px-2 text-base': size === 'xs',
			})}
			onClick={handleOnClick}
		>
			<div className="flex items-center justify-center whitespace-nowrap">
				{children}
			</div>
		</button>
	)
}

export default TWButton